import React, { Fragment, useState, useRef, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import Modal from '../../common/Modal';
import Button from "../../Button";
import styles from '../Forms/StudentImport/StudentImport.module.sass'
import Select from 'react-select';
import AsyncSelect from 'react-select/async'
import School from "../../../models/School";
import axios from 'axios';

const ButtonTrigger = ({ jobs, scheduledJobs, jobYears, backgrounds }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState()
  const [school, setSchool] = useState();
  const [job, setJob] = useState();
  const [scheduledJob, setScheduledJob] = useState();
  const [clearExports, setClearExports] = useState(false);
  const [filter, setFilter] = useState(0);
  const [isTest, setIsTest] = useState(false);
  const [scheduledJobLabel, setScheduledJobLabel] = useState();
  const [year, setYear] = useState();
  const [backgroundId, setBackgroundId] = useState(null);
  const [missingImages, setMissingImages] = useState(null);
  const [allPhotosFound, setAllPhotosFound] = useState(null);
  const form = useRef(null)

  const formattedScheduledJobs = () => scheduledJobs.map(job => ({ label: job.label, value: job.value }))
  const selectedScheduledJob = () => scheduledJobs.find(job => job.label === scheduledJobLabel)

  const openModal = () => setIsOpen(true);
  const closeModal = () => {
    setIsOpen(false)
    setIsSubmitting(false)
    setMissingImages(null)
    setAllPhotosFound(null)
    setFormData()
  };
  const { register, handleSubmit, control, setValue } = useForm();

  const triggerJob = (excludeIds) => {
    const formData = new FormData(form.current)

    formData.append('school_id', school)
    formData.append('job', job)
    formData.append('scheduled_job', scheduledJob)
    formData.append('year', year)
    formData.append('clear', clearExports)
    formData.append('filter', filter)
    formData.append('test', isTest)
    if (backgroundId) {
      formData.append('background_id', backgroundId)
    }
    if (excludeIds && excludeIds.length > 0) {
      excludeIds.forEach(id => formData.append('exclude_ids[]', id))
    }

    axios.post('/admin/generated_products/trigger.js', formData)
      .then((res) => {
        if (res.data.status === 200) {
          const msg = excludeIds && excludeIds.length > 0
            ? `Generating covers (skipping ${excludeIds.length} with missing photos).`
            : 'Students are now generating in the background.';
          toast(msg, { type: 'success' });
          closeModal();
        } else {
          toast(res.data.errors,
            { type: 'error' });
        }
      })
  }

  const onSubmit = () => {
    setIsSubmitting(true)

    if (scheduledJobLabel?.includes('Yearbook Covers')) {
      const formData = new FormData()
      formData.append('school_id', school)
      formData.append('scheduled_job', scheduledJob)
      formData.append('filter', filter)

      axios.post('/admin/generated_products/check_missing_images.json', formData)
        .then((res) => {
          if (res.data.missing && res.data.missing.length > 0) {
            setMissingImages(res.data)
            setIsSubmitting(false)
          } else {
            setAllPhotosFound(res.data)
            setIsSubmitting(false)
          }
        })
        .catch(() => {
          toast('Error checking for missing images', { type: 'error' })
          setIsSubmitting(false)
        })
    } else {
      triggerJob()
    }
  }

  const loadSchoolOptionsQuery = ({ valueField }) => (value, callback) => {
    School
      .where({
        sales_stat: { match: 'CUST' },
        name: { match: value },
      })
      .order({ name: 'asc' })
      .all()
      .then((res) => {
        const options = res.data.map((e) => ({ label: e.name, value: e.id, data: e }))
        callback(options)
      })
  }

  const loadSchoolOptions = loadSchoolOptionsQuery('name')

  const renderAllPhotosFound = () => {
    const { total_personalized, total } = allPhotosFound;

    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <h4 style={{ color: '#27ae60', marginBottom: '15px' }}>
          All photos found for {total_personalized} personalized covers
        </h4>
        <p style={{ color: '#666', fontSize: '13px', marginBottom: '20px' }}>
          Total covers to generate: {total} ({total_personalized} personalized, {total - total_personalized} non-personalized)
        </p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
          <button
            type="button"
            className="btn btn-success btn-lg"
            onClick={() => {
              setIsSubmitting(true)
              setAllPhotosFound(null)
              triggerJob()
            }}
          >
            Print Covers
          </button>
          <button
            type="button"
            className="btn btn-default btn-lg"
            onClick={() => {
              setAllPhotosFound(null)
              setIsSubmitting(false)
            }}
          >
            Go Back
          </button>
        </div>
      </div>
    )
  }

  const renderMissingImagesReport = () => {
    const { missing, total_personalized, total } = missingImages;

    return (
      <div>
        <h4 style={{ color: '#c0392b', marginBottom: '10px' }}>
          {missing.length} of {total_personalized} personalized covers are missing student pictures
        </h4>
        <p style={{ color: '#666', fontSize: '13px' }}>
          Total covers to generate: {total} ({total_personalized} personalized, {total - total_personalized} non-personalized)
        </p>

        <div id="missing-images-list">
          <table className="table table-condensed table-striped" style={{ fontSize: '13px', marginTop: '10px' }}>
            <thead>
              <tr>
                <th>Student Name</th>
                <th>Grade</th>
                <th>Teacher</th>
                <th>Item #</th>
              </tr>
            </thead>
            <tbody>
              {missing.map((item) => (
                <tr key={item.order_package_id}>
                  <td>{item.student_name}</td>
                  <td>{item.grade}</td>
                  <td>{item.teacher}</td>
                  <td>{item.order_package_id}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={{ marginTop: '15px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <button
            type="button"
            className="btn btn-success"
            onClick={() => {
              const excludeIds = missing.map(m => m.order_package_id);
              setIsSubmitting(true)
              setMissingImages(null)
              triggerJob(excludeIds)
            }}
          >
            Print covers with photos ({total_personalized - missing.length} of {total_personalized})
          </button>
          <button
            type="button"
            className="btn btn-default"
            onClick={() => {
              setMissingImages(null)
              setIsSubmitting(false)
            }}
          >
            Go Back
          </button>
          <button
            type="button"
            className="btn btn-info"
            onClick={() => {
              const printContent = document.getElementById('missing-images-list').innerHTML;
              const win = window.open('', 'PRINT', 'height=600,width=800');
              win.document.write('<html><head><title>Missing Student Pictures</title>');
              win.document.write('<style>table{border-collapse:collapse;width:100%}th,td{border:1px solid #ddd;padding:6px 8px;text-align:left}th{background:#f5f5f5;font-weight:bold}</style>');
              win.document.write('</head><body>');
              win.document.write('<h3>Missing Student Pictures - ' + missing.length + ' orders</h3>');
              win.document.write(printContent);
              win.document.write('</body></html>');
              win.document.close();
              win.print();
            }}
          >
            Print List
          </button>
        </div>
      </div>
    )
  }

  const renderForm = () => {
    return (
      <form ref={form} onSubmit={handleSubmit(onSubmit)} className={styles.form}>
        School
        <AsyncSelect
          cacheOptions
          defaultOptions
          placeholder="Select the school for the student"
          name={name}
          loadOptions={loadSchoolOptions}
          onChange={(opt) => setSchool(opt.value)}
        />

        <br/>

        Job
        <Select
          placeholder="Jobs"
          options={jobs}
          width="100px"
          onChange={(e) => setJob(e.value)}
        />

        <br/>

        Scheduled Job
        <Select
          placeholder="Scheduled Job"
          options={formattedScheduledJobs()}
          width="100px"
          onChange={(e) => {
            setScheduledJob(e.value);
            setScheduledJobLabel(e.label)
          }}
        />

        <br/>

        Year the job takes place
        <Select
          placeholder="Job year"
          options={jobYears}
          width="100px"
          onChange={(e) => setYear(e.value)}
        />

        {scheduledJobLabel?.includes('Yearbook Covers') && (
          <>
            <br />
            <input
              type="checkbox"
              className={styles.checkbox}
              onChange={(e) => setClearExports(!clearExports)} />
            Clear existing exported yearbook covers and generate all

            <br/>

            <hr />
            Filter:
            <div>
              <input type="radio" value="not_printed" name="filter" onChange={() => setFilter('not_printed')} /> All orders for which cover printed boolean is not set <br/>
              <input type="radio" value="not_shipped" name="filter" onChange={() => setFilter('not_shipped')} /> All orders for which ship date is null
            </div>
          </>
        )}

        {selectedScheduledJob()?.audience === 'Parents' && (
          <>
            <br />
            <input
              type="checkbox"
              className={styles.checkbox}
              onChange={(e) => setIsTest(!isTest)} />
            Trigger as a test
          </>
        )}

        {scheduledJobLabel?.startsWith('Pic4tea') && backgrounds && (
          <>
            <br />
            Background (optional)
            <Select
              placeholder="Use school default"
              options={backgrounds}
              isClearable
              onChange={(e) => setBackgroundId(e?.value || null)}
            />
          </>
        )}

        <div className={styles.formActions}>
          <Button
            fullWidth
            variant='primary'
            disabled={!school || !job || !scheduledJob || !year}
          >
            Continue
          </Button>
        </div>
      </form>
    )
  }

  return (
    <Fragment>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Modal
        modalBodyProps={{ className: styles.modalBody }}
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel="Trigger Scheduled Job"
        headerText="Trigger Scheduled Job"
      >
        {missingImages ? renderMissingImagesReport() : allPhotosFound ? renderAllPhotosFound() : renderForm()}
      </Modal>

      <Button onClick={openModal} variant={'primary'} fullWidth={true}>
        Trigger Scheduled Job
      </Button>
    </Fragment>
  )
}

export default ButtonTrigger;
